import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTheme } from "../../context/ThemeContext";

const CountrySelect = ({ className, options, setOpenTab }) => {
  const { colorMode } = useTheme();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: colorMode === "light" ? "#4D5A62" : "#303030",
      borderRadius: "5px",
      padding: "0px",
      zIndex: "10",
      border: "0px",
      boxShadow: "none",
      filter:
        colorMode === "light"
          ? "drop-shadow(4px 4px 20px rgba(77, 90, 98, 0.2))"
          : "drop-shadow(0px 10px 5px rgba(0, 0, 0, 0.25))"
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "12px 0 12px 20px"
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "0px",
      background: "none !important",
      marginTop: "-4px !important"
    }),
    menuList: (provided, state) => ({
      ...provided,
      borderRadius: "0px 0px 5px 5px",
      padding: "10px 20px 24px 20px",
      backgroundColor:
        colorMode === "light"
          ? "rgba(77, 90, 98, 0.15)"
          : "rgba(255, 255, 255, 0.15)",
      backdropFilter: "blur(50px)",
      maxHeight: "auto !important"
    }),
    option: (provided, state) => ({
      ...provided,
      color: colorMode === "light" ? "#4D5A62" : "white",
      backgroundColor: "transparent",
      borderBottom:
        colorMode === "light"
          ? "1px solid rgba(77,90,98,0.3)"
          : "1px solid rgba(231,231,242,0.3)",
      padding: "14px 0 7px 0",
      display: state.isSelected ? "none" : "block",
      zIndex: 20,
      "&:active": {
        backgroundColor: "transparent"
      }
    }),
    singleValue: (provided, state) => {
      const color = "white";
      return { ...provided, color };
    },
    dropdownIndicator: (base) => ({
      ...base,
      color: "white",
      "&:hover": {
        color: "white"
      }
    }),
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#ffffff"
      };
    },
    indicatorSeparator: () => null
  };
  const [selectedValue, setValue] = useState(0);
  useEffect(() => {
    setValue(undefined);
  }, [options]);

  const handleMenu = (event) => {
    setValue(event.value);
    setOpenTab(event.id);
  };
  return (
    <Select
      options={options}
      value={
        selectedValue
          ? options.find((c) => c.value === selectedValue)
          : selectedValue
      }
      onChange={handleMenu}
      className={className}
      styles={customStyles}
      placeholder={"Choose a country"}
      isSearchable={false}
    />
  );
};

export default CountrySelect;
